<ppg-cta-card-template
  [url]="listAssetYoutubeVideoCard().content.url"
  [target]="urlTarget.BLANK"
  [template]="listAssetYoutubeVideoCardTemplateRef"></ppg-cta-card-template>

<ng-template #listAssetYoutubeVideoCardTemplateRef>
  <p-card [title]="listAssetYoutubeVideoCard().content.title" class="card-cta-hover list-presentation-card">
    <div class="card-title list-presentation-card-title">
      <i class="pi pi-link link-icon"></i>
      <div class="list-presentation-content-container">
        <ppg-card-title class="primary-card-title" [title]="listAssetYoutubeVideoCard().content.title"></ppg-card-title>
        <ppg-card-arrow-up-right [target]="urlTarget.BLANK"></ppg-card-arrow-up-right>
      </div>
    </div>
  </p-card>
</ng-template>
